<template>
    <div class="news">
        <!-- <div class="img-header">
            <img src="@/assets/image/news.webp" alt="新闻动态" class="news-image" />
        </div> -->
        <div class="spacer"></div> <!-- 新增的白色 div -->
        <div class="news-list">
            <router-link :to="{ name: 'NewsDetail', params: { id: news.id } }" class="news-item" v-for="news in paginatedNews" :key="news.id">
                <div class="news-item-image">
                <img :src="news.image" :alt="news.title" />
                </div>
                <div class="news-item-content">
                <h3 class="news-title">{{ news.title }}</h3>
                <p>{{ news.summary }}</p>
                </div>
                <div class="news-item-date">
                <p class="news-day">{{ news.date.split('-')[2] }}</p>
                <p class="news-year-month">{{ news.date.split('-')[0] }}-{{ news.date.split('-')[1] }}</p>
                </div>
            </router-link>
        </div>
        <div class="pagination">
            <button @click="prevPage" :disabled="currentPage === 1">上一页</button>
            <span>{{ currentPage }} / {{ totalPages }}</span>
            <button @click="nextPage" :disabled="currentPage === totalPages">下一页</button>
        </div>
        <div class="footer-section">
            <div class="footer-left">
                <p>版权所有  2025 百亩林</p>
                <router-link to="/honour" class="license-link">营业执照</router-link>
            </div>
            <div class="footer-right">
                <p>备案号：XYZ123456789</p>
                <!-- <div class="qr-code">
                    <img src="@/assets/image/logo.png" alt="二维码" class="qr-image" />
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue'; // 引入 Footer 组件
export default {
    name: 'News',
    components: {
        Footer
    },
    data() {
        return {
            newsList: [
                {
                    id: 1,
                    title: '三门峡市委书记来沿黄示范村和百亩林公司指导工作',
                    date: '2024-9-05',
                    summary: '2024年金秋九月，三门峡市市委书记范付中同志来到炎黄经济示范村和百亩林公司视察并指导工作',
                    content: '<p>2024年金秋九月，三门峡市市委书记范付中同志来到炎黄经济示范村和百亩林公司视察并指导工作，鼓励大家继续努力，为乡村振兴做出更多贡献。范书记非常重视黄河沿岸的经济带乡村与产业的发展工作，指出要聚焦重点全力实施乡村振兴战略，高标准打造炎黄乡村振兴示范带。</p>',
                    image: require('@/assets/image/news1.jpg') // 使用 require 确保路径正确
                },
                {
                    id: 2,
                    title: '百亩林公司邀请中国农业大学留学生体验枣文化',
                    date: '2025-02-10',
                    summary: '百亩林公司邀请何教授和留学生来公司基地体验红枣产品',
                    content: '<p>2025年2月10-13日，弘农书院创始人何慧丽教授带领来自埃塞俄比亚、马拉维、厄瓜多尔、塞拉利昂、坦桑尼亚等5国6名留学生，来灵宝地区进行乡土文明与国际视野交流活动。百亩林公司邀请何教授和留学生来公司基地体验红枣产品，公司生产的手工炒制灵宝大枣枣茶杯受到大家的一致好评！</p>',
                    image: require('@/assets/image/news2.jpg') // 使用 require 确保路径正确
                },
                {
                    id: 3,
                    title: '百亩林公司参与本土社火表演活动',
                    date: '2025-02-12',
                    summary: '由灵宝各级政府和群众举办的"正巳春风暖金城"元宵节社火表演火热开演，万名群众欢聚，共绘新春画卷，百亩林公司全体员工参与社火表演活动，其乐融融。',
                    content: '<p>2025年2月12日，由灵宝各级政府和群众举办的"正巳春风暖金城"元宵节社火表演火热开演，万名群众欢聚，共绘新春画卷，百亩林公司全体员工参与社火表演活动，其乐融融。</p>',
                    image: require('@/assets/image/news3.jpg') // 添加图片路径
                }
            ],
            currentPage: 1
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.newsList.length / 3);
        },
        paginatedNews() {
            const start = (this.currentPage - 1) * 3;
            const end = start + 3;
            return this.newsList.slice(start, end);
        }
    },
    methods: {
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
            }
        }
    }
}
</script>
<style scoped>
.news {
  text-align: center;
  padding-top: 40px;
  background-color: #f5f5f5;
}

.img-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.news-image {
  max-height: 450px; /* 增加高度 */
  width: 100%;
}

.spacer {
  height: 80px;
  background-color: white;
}

.news-list {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
  padding: 0 20px;
}

.news-item {
  background-color: white;
  border-radius: 12px;
  padding: 20px;
  margin: 20px 0;
  width: 90%;
  height: 200px; /* 固定高度 */
  display: flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.news-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.news-item-image {
  flex: 0 0 200px; /* 固定宽度 */
  height: 160px; /* 固定高度 */
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 8px;
  margin-right: 20px;
}

.news-item-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.news-item-content {
  flex: 1;
  height: 160px; /* 与图片高度一致 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 20px;
  text-align: left;
  overflow: hidden;
}

.news-item-date {
  flex: 0 0 120px; /* 固定宽度 */
  height: 160px; /* 与图片高度一致 */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding-left: 20px;
  border-left: 1px solid #eee;
}

.news-title {
  font-size: 1.5em;
  margin: 0 0 15px;
  color: #333;
  line-height: 1.4;
}

.news-item-content p {
  margin: 8px 0;
  color: #666;
  font-size: 1.1em;
  line-height: 1.6;
}

.news-day {
  font-size: 2em;
  margin: 0;
  color: #28a745;
  font-weight: bold;
}

.news-year-month {
  font-size: 1.2em;
  margin: 5px 0 0;
  color: #666;
}

.footer-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-top: 1px solid #ccc;
}

.footer-left {
  flex: 1;
  text-align: left;
}

.footer-left p {
  margin: 5px 0;
}

.footer-left .license-link {
  color: blue;
  text-decoration: none;
}

.footer-right {
  flex: 1;
  text-align: right;
}

.footer-right p {
  margin: 5px 0;
}

.qr-code {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.qr-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  margin-top: 10px;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px 0;
  gap: 15px;
}

.pagination button {
  background-color: #28a745;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9em;
}

.pagination button:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-2px);
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination span {
  font-size: 0.9em;
  color: #666;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .news {
    padding-top: 20px;
  }

  .spacer {
    height: 60px;
  }

  .news-item {
    width: 95%;
    height: auto;
    flex-direction: column;
    padding: 15px;
  }

  .news-item-image {
    flex: 0 0 200px;
    width: 100%;
    height: 200px;
    margin-right: 0;
    margin-bottom: 15px;
  }

  .news-item-content {
    width: 100%;
    height: auto;
    padding: 0;
    margin-bottom: 15px;
  }

  .news-item-date {
    width: 100%;
    height: auto;
    flex-direction: row;
    justify-content: center;
    padding-left: 0;
    border-left: none;
    border-top: 1px solid #eee;
    padding-top: 15px;
  }

  .news-title {
    font-size: 1.3em;
    margin-bottom: 10px;
  }

  .news-item-content p {
    font-size: 1em;
    margin: 6px 0;
  }

  .news-day {
    font-size: 1.6em;
    margin-right: 10px;
  }

  .news-year-month {
    font-size: 1.1em;
  }

  .pagination {
    margin: 20px 0;
  }

  .pagination button {
    padding: 6px 12px;
    font-size: 0.85em;
  }
}

@media screen and (max-width: 480px) {
  .news-item {
    width: 98%;
    padding: 12px;
  }

  .news-item-image {
    height: 180px;
  }

  .news-title {
    font-size: 1.2em;
  }

  .news-item-content p {
    font-size: 0.95em;
  }

  .news-day {
    font-size: 1.4em;
  }

  .news-year-month {
    font-size: 1em;
  }

  .pagination button {
    padding: 5px 10px;
    font-size: 0.8em;
  }
}
</style>
